import { render } from "./purchaselist.vue?vue&type=template&id=0747134a"
import script from "./purchaselist.vue?vue&type=script&lang=js"
export * from "./purchaselist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__